import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { heIL } from "@mui/x-date-pickers/locales";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useAppRoutes } from "./AppRoutes";
import dayjs from "dayjs";
import "dayjs/locale/he";

import { RouterProvider } from "react-router-dom";
import "../Index.scss";

dayjs.locale("he");

const theme = createTheme({
  direction: "rtl",
  components: {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          "& .MuiMonthCalendar-root": { direction: "ltr" },
          "& .MuiYearCalendar-root": { direction: "ltr" },
        },
      },
    },
  },
});

const nonce = (
  document.querySelector("meta[name='csp-nonce']") as { content: string } | null
)?.content;

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
  prepend: true,
  nonce,
});

export default function App() {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="he"
          localeText={
            heIL.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          <RouterProvider router={useAppRoutes()} />
          {/* <Test /> */}
        </LocalizationProvider>
      </ThemeProvider>
    </CacheProvider>
  );
}
